module.exports = __webpack_public_path__ + "img/life-loving.e2f6f73b.jpg";